var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":'מעולה, אין לנו עוד שאלות.',"text":'אנחנו נעדכן את התזרים בהתאם ונעדכן אותך ב-WhatsApp ברגע שיהיה מוכן.',"notification-buttons":[
                      {
                        title:'הבנתי, תודה!',
                        size: 'slim',
                        variant: 'primary',
                        action: _vm.onClose,
                      } ],"icon-type":'warning'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }